// React dependencies
import React, { useState } from 'react';

// External dependencies
import PropTypes from 'prop-types';
import { FileCopy, ReportProblemOutlined } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { toast } from 'react-toastify';

// Internal dependencies
import MText from './MText';
import { IsEmpty } from '../../common/checks';

const SupportIdAlert = (props) => {
  const [copied, setCopied] = useState(false);

  if (IsEmpty(props.requestId)) {
    return null;
  }

  const copyOnClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (error) {
      toast.error(error?.message || 'Failed to copy the ID');
    }
  };

  return (
    <div
      className="alert alert-danger d-flex flex-column w-100"
      style={{ borderRadius: 8 }}
    >
      <div className="d-flex flex-row" style={{ columnGap: 8 }}>
        <div className="flex-shrink-0">
          <ReportProblemOutlined />
        </div>
        <div>
          <MText
            colour="inherit"
            text={props.alertMessage}
          />
          <div
            className="d-flex flex-row align-items-center mt-2"
            style={{ minHeight: 30 }}
          >
            <MText colour="inherit" style={{ flex: 1 }} size={16} bold text={props.requestId} />
            <div className="flex-shrink-0">
              {
                copied ? (
                  <MText colour="inherit" text="Copied" />
                ) : (
                  <IconButton style={{ color: 'inherit' }} size="small" onClick={() => copyOnClick(props.requestId)}>
                    <FileCopy style={{ color: 'inherit' }} />
                  </IconButton>
                )
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

SupportIdAlert.propTypes = {
  requestId:    PropTypes.string,
  alertMessage: PropTypes.string,
};

SupportIdAlert.defaultProps = {
  requestId:    null,
  alertMessage: 'Could not update the post. Please report this to the dev team with the Support ID below',
};

export default SupportIdAlert;
